<template>
    <div class="cockpit-chart">
        <!-- TÍTULO -->
        <div class="chart-title">
            {{ title }}
        </div>

        <!-- CONTEÚDO -->
        <div ref="chartContent" class="chart-content" v-if="!noData">
            <svg class="chart_v" ref="svgcontent" width="500" height="300"></svg>
        </div>

        <!-- FOOTER -->
        <div class="chart-footer" v-if="!noData">
            <div ref="LGbox" class="legend-chart"></div>
        </div>

        <!-- MSG NÃO HÁ DADOS -->
        <div class="chart-no-text" v-if="noData">
            <svg class="fail">
                <use :xlink:href="require('@/assets/img/icons/chart-error.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('chart-no-data') }}</div>
        </div>
    </div>
</template>
<script>
import CockpitChart from '@/components/shared/chart/CockpitChart';
import { palette as paleta } from '@/functions/color/Palette';

export default {
    extends: CockpitChart,
    props: ['title', 'datacontent'],
    data() {
        return {
            datacaption: [],
            dataset: [],
            cores: [],
            filtered: [],
            noData: false,
        };
    },
    created() {
        this.cores = paleta.barColors;
    },
    mounted() {
        this.dataset = this.datacontent;
        // let captionsize = 0;
        let keys = [];

        this.dataset.forEach((d) => {
            for (var key in d) {
                if (key != 'row' && key != 'total' && keys.indexOf(key) < 0) {
                    keys.push(key);
                }
            }
        });

        for (var key of keys) {
            this.datacaption.push(key);
        }

        if (!this.dataset || this.dataset.length <= 0) {
            this.noData = true;
        } else {
            this.svgStackBarChart();
        }
    },
    methods: {
        svgStackBarChart() {
            var width = this.$refs.chartContent.offsetWidth;
            var height = this.$refs.chartContent.offsetHeight;
            var margin = { top: 20, right: 20, bottom: 30, left: 40 };
            var w = width - margin.left - margin.right;
            var h = height - margin.top - margin.bottom;

            var svg = this.$d3.select(this.$refs.svgcontent),
                g = svg
                    .append('g')
                    .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var x = this.$d3.scaleBand().rangeRound([0, w]).padding(0.2);

            var y = this.$d3.scaleLinear().rangeRound([h, 0]);

            var stack = this.$d3.stack();

            var color = this.$d3.scaleOrdinal(this.cores);

            var div = this.$d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            var keys = [];
            this.dataset.forEach((d) => {
                for (var key in d) {
                    if (key != 'row' && keys.indexOf(key) < 0 && key != 'total') keys.push(key);
                }
            });

            this.dataset.forEach(function (d) {
                d.total = 0;
                keys.forEach(function (k) {
                    if (d[k]) {
                        d.total += d[k];
                    }
                });
            });

            x.domain(
                this.dataset.map(function (d) {
                    return d.row;
                })
            );
            y.domain([
                0,
                this.$d3.max(this.dataset, function (d) {
                    return d.total;
                }),
            ]).nice();
            color.domain(keys);

            g.append('g')
                .selectAll('g')
                .data(stack.keys(keys)(this.dataset))
                .enter()
                .append('g')
                .attr('fill', function (d) {
                    return color(d.key);
                })
                .selectAll('rect')
                .data(function (d) {
                    return d.filter((l) => {
                        return l.key != 'total';
                    });
                })
                .enter()
                .append('rect')
                .on('mouseover', (d, i) => {
                    div.transition()
                        .duration(200)
                        .style('opacity', this.legendOpacity)
                        .style('color', '#FFF');
                    div.html(this.getStackText(this.dataset[i], color))
                        .style('left', this.$d3.event.pageX - div.node().offsetWidth / 2 + 'px')
                        .style('top', this.$d3.event.pageY - 15 * (this.dataset.length + 1) + 'px')
                        .style('text-transform', 'capitalize');
                })
                .on('mousemove', (d) => {
                    div.style(
                        'left',
                        this.$d3.event.pageX - div.node().offsetWidth / 2 + 'px'
                    ).style('top', this.$d3.event.pageY - div.node().offsetHeight + 'px');
                })
                .on('mouseout', (d) => {
                    div.transition().duration(500).style('opacity', 0);
                })
                .attr('class', 'stacked')
                .attr('width', x.bandwidth)
                .attr('x', (d) => {
                    return x(d.data.row);
                })
                .attr('y', h)
                .transition()
                .duration(400)
                .attr('y', function (d) {
                    return y(d[1]);
                })
                .attr('height', function (d) {
                    return y(d[0]) - y(d[1]);
                });

            g.append('g')
                .attr('class', 'axis')
                .attr('transform', 'translate(0,' + h + ')')
                .call(this.$d3.axisBottom(x));

            g.append('g').attr('class', 'axis').call(this.$d3.axisLeft(y).ticks(null, 's'));

            var legends = this.$d3
                .select(this.$refs.LGbox)
                // var legends = chart.append("g")
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .attr('text-transform', 'uppercase')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', (d) => {
                    //
                    // Update the array to filter the chart by:
                    //

                    // add the clicked key if not included:
                    if (this.filtered.indexOf(d) == -1) {
                        this.filtered.push(d);
                        // if all bars are un-checked, reset:
                        if (this.filtered.length == color.domain().length) this.filtered = [];
                    }
                    // otherwise remove it:
                    else {
                        this.filtered.splice(this.filtered.indexOf(d), 1);
                    }
                    //
                    // Update the scales for each group(/states)'s items:
                    //
                    var newKeys = [];
                    color.domain().forEach((d) => {
                        if (this.filtered.indexOf(d) == -1 && d) {
                            newKeys.push(d);
                        }
                    });
                    var fKeys = [];
                    this.dataset.forEach((d) => {
                        for (var key in d) {
                            if (
                                key != 'row' &&
                                key != 'total' &&
                                fKeys.indexOf(key) < 0 &&
                                this.filtered.indexOf(key) == -1
                            ) {
                                fKeys.push(key);
                            }
                        }
                    });

                    let count = 0;
                    // let whichrow;
                    var filteredDataset = [];

                    this.dataset.forEach((d) => {
                        count++;
                        let dt = {};
                        Object.entries(d).forEach((i) => {
                            if (i[0] == 'row') dt.row = i[1];

                            if (i != '__ob__') {
                                if (newKeys.indexOf(i[0]) > -1) {
                                    dt[i[0]] = i[1];
                                }
                            }
                        });
                        filteredDataset.push(dt);
                        // d.datacontent.sort((d1, d2) => d1.row.localeCompare(d2.row));
                    });

                    filteredDataset.forEach(function (d) {
                        d.total = 0;
                        newKeys.forEach(function (k) {
                            if (d[k]) {
                                d.total += d[k];
                            }
                        });
                    });

                    y.domain([
                        0,
                        this.$d3.max(filteredDataset, (d) => {
                            return d.total;
                        }),
                    ]).nice();

                    filteredDataset.forEach(function (d) {
                        d.total = 0;
                        keys.forEach(function (k) {
                            if (d[k]) {
                                d.total += d[k];
                            }
                        });
                    });

                    g.selectAll('g').remove();

                    g.append('g')
                        .selectAll('g')
                        .data(stack.keys(keys)(filteredDataset))
                        .enter()
                        .append('g')
                        .attr('fill', function (d) {
                            return color(d.key);
                        })
                        .selectAll('rect')
                        .attr('class', 'd3-column')
                        .data(function (d) {
                            return d.filter((l) => {
                                return d.key != 'total';
                            });
                        })
                        .enter()
                        .append('rect')
                        .on('mouseover', (d, i) => {
                            div.transition()
                                .duration(200)
                                .style('opacity', this.legendOpacity)
                                .style('color', '#FFF');
                            //   .style("background-color", "#000")
                            div.html(this.getStackText(filteredDataset[i], color))
                                .style(
                                    'left',
                                    this.$d3.event.pageX - div.node().offsetWidth / 2 + 'px'
                                )
                                .style(
                                    'top',
                                    this.$d3.event.pageY - 15 * (filteredDataset.length + 1) + 'px'
                                )
                                .style('text-transform', 'capitalize');
                        })
                        .on('mousemove', (d) => {
                            div.style(
                                'left',
                                this.$d3.event.pageX - div.node().offsetWidth / 2 + 'px'
                            ).style('top', this.$d3.event.pageY - div.node().offsetHeight + 'px');
                        })
                        .on('mouseout', (d) => {
                            div.transition().duration(500).style('opacity', 0);
                        })
                        .attr('class', 'stacked')
                        .attr('width', x.bandwidth)
                        .attr('x', (d) => {
                            return x(d.data.row);
                        })
                        .attr('y', h)
                        .transition()
                        .duration(400)
                        .attr('y', function (d) {
                            return y(d[1]);
                        })
                        .attr('height', function (d) {
                            return y(d[0]) - y(d[1]);
                        });

                    g.append('g').attr('class', 'axis').call(this.$d3.axisLeft(y).ticks(null, 's'));

                    g.append('g')
                        .attr('class', 'axis')
                        .attr('transform', 'translate(0,' + h + ')')
                        .call(this.$d3.axisBottom(x));

                    // update legend:
                    legends.style('opacity', (d) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                });

            legends
                .append('div')
                .style('width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                .style('background', color);

            legends
                .append('p')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },
        getStackText(data, color) {
            let text = '';
            let a = 0;
            for (let i in data) {
                if (a > 0) {
                    if (i != 'total') {
                        text +=
                            "<div class='tooltip-color' style='background-color: " +
                            color(i) +
                            "' ></div>";
                    }
                    text += i + ': ';
                }
                text += i != 'row' ? Math.round(data[i] * 100) / 100 : data[i];
                text += '</br>';
                a++;
            }
            return text;
        },
        redrawChart() {
            this.$d3.select(this.$refs.svgcontent).select('g').remove();
            this.$d3.select(this.$refs.LGbox).selectAll('.legend-box').remove();
            this.svgStackBarChart();
        },
    },
};
</script>
